import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {createFrom, EventService} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';
import {Observable} from 'rxjs';
import {NavigationEvent} from '@spartacus/storefront';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {filter, map} from 'rxjs/operators';
import {OrderConfirmationPageEvent} from './order-confirmation-page-event';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class OrderConfirmationPageEventService {
  constructor(@Inject(PLATFORM_ID) public platformId: string, protected event: EventService) {
    this.register();
  }

  protected register(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.event.register(OrderConfirmationPageEvent, this.buildConfiguratorPageEvent());
  }

  protected buildConfiguratorPageEvent(): Observable<OrderConfirmationPageEvent> {
    return this.event.get(NavigationEvent).pipe(
      untilDestroyed(this),
      filter((navigationEvent) => navigationEvent.semanticRoute === 'orderConfirmation'),
      map((navigationEvent) =>
        createFrom(OrderConfirmationPageEvent, {
          navigation: navigationEvent,
        })
      )
    );
  }
}
